import ContactSection from "./ContactSection";
import FaqSection from "./FaqSection";
import FinalFooter from "./FinalFooter";
import HeroSection from "./HeroSection";
import OutcomesSection from "./OutcomesSection";
import ProgramsSection from "./ProgramsSection";
import PublicNav from "./PublicNav";
import TestimonialsSection from "./TestimonialsSection";
import TrendingCourses from "./TrendingCourses";

export default function PublicLandingPage() {
    return <div className="mockzo-public">
        <PublicNav />
        <main>
            <HeroSection />
            <TrendingCourses />
            <ProgramsSection />
            <OutcomesSection />
            <TestimonialsSection />
            <FaqSection />
            <ContactSection />
            <FinalFooter />
        </main>
    </div>;
}
